import { cloneDeep } from "lodash";
import storageService from "../../services/storage/storageService";

const SET_MARKET = "app/configs/SET_MARKET";
const SET_USER_MARKET_FILTER = "app/configs/SET_USER_MARKET_FILTER";
const SET_USER_MARKETS = "app/configs/SET_USER_MARKETS";
const SET_USER_ROLES = "app/configs/SET_USER_ROLES";
const RESET_USER_ROLES = "app/configs/RESET_USER_ROLES";
const SET_LOCATIONS = "app/configs/SET_LOCATIONS";
const RESET_LOCATIONS = "app/configs/RESET_LOCATIONS";
const SET_LOADING = "app/configs/SET_LOADING";
const SET_LOADING_ID = "app/configs/SET_LOADING_ID";
const REMOVE_LOADING_ID = "app/configs/REMOVE_LOADING_ID";
const SET_ERROR = "app/configs/SET_ERROR";
const SET_USER_APP_TYPES = "app/configs/SET_USER_APP_TYPES";
const SET_APP_TYPES_GROUPS = "app/configs/SET_APP_TYPES_GROUPS";
const SET_GROUPS_CONFIGS = "app/configs/SET_GROUPS_CONFIGS";
const RESET_GROUPS_CONFIGS = "app/configs/RESET_GROUPS_CONFIGS";
const SET_APP_VERSION = "app/configs/SET_APP_VERSION";
const SET_IS_NEED_TO_RESET_TEXT_EDITOR_STATE = "app/global/SET_IS_NEED_TO_RESET_TEXT_EDITOR_STATE";

const initialState = {
  marketIso: "",
  userMarkets: null,
  userRoles: [],
  locations: {},
  loading: false,
  loadingIds: [],
  error: null,
  appTypesGroups: [],
  appTypes: null,
  userMarketFilter: null,
  groupsConfigs: {},
  appVersion: null,
  isNeedToResetTextEditorState: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_MARKET: {
      const clonedState = cloneDeep(state);

      // if we set market to null, it won't be replaced in the local storage
      if (action.payload) {
        storageService.setMarketToStorage(action.payload);
      }

      return { ...clonedState, marketIso: action.payload };
    }

    case SET_USER_MARKET_FILTER: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, userMarketFilter: action.payload };
    }

    case SET_USER_MARKETS: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, userMarkets: action.payload };
    }

    case SET_USER_ROLES: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, userRoles: action?.payload };
    }

    case RESET_USER_ROLES: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, userRoles: [] };
    }

    case SET_LOCATIONS: {
      const clonedState = cloneDeep(state);
      const newLocations = cloneDeep(clonedState.locations);

      if (action?.payload?.market && action?.payload?.locations) {
        newLocations[action?.payload?.market] = action?.payload?.locations;
      }

      return { ...clonedState, locations: newLocations };
    }

    case RESET_LOCATIONS: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, locations: {} };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_LOADING_ID: {
      const clonedState = cloneDeep(state);

      const newloadingIds = clonedState?.loadingIds
        ? [...clonedState.loadingIds, action.payload]
        : [action.payload];

      return {
        ...clonedState,
        loadingIds: newloadingIds
      };
    }

    case REMOVE_LOADING_ID: {
      const clonedState = cloneDeep(state);

      const newloadingIds = clonedState?.loadingIds
        ? clonedState.loadingIds.filter((id) => id !== action.payload)
        : [];

      return {
        ...clonedState,
        loadingIds: newloadingIds
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    case SET_APP_TYPES_GROUPS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        appTypesGroups: action.payload
      };
    }

    case SET_USER_APP_TYPES: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        appTypes: action.payload
      };
    }

    case SET_GROUPS_CONFIGS: {
      const clonedState = cloneDeep(state);
      const newGroupsConfigs = cloneDeep(clonedState.groupsConfigs);

      if (action?.payload?.appType && action?.payload?.groups) {
        newGroupsConfigs[action?.payload?.appType] = action?.payload?.groups;
      }

      return { ...clonedState, groupsConfigs: newGroupsConfigs };
    }

    case RESET_GROUPS_CONFIGS: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, groupsConfigs: {} };
    }

    case SET_APP_VERSION: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, appVersion: action?.payload };
    }

    case SET_IS_NEED_TO_RESET_TEXT_EDITOR_STATE: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, isNeedToResetTextEditorState: action?.payload };
    }

    default: {
      return state;
    }
  }
}

export const setMarketIso = (marketIso) => ({ type: SET_MARKET, payload: marketIso });

export const setUserMarketFilter = (userMarketFilter) => ({
  type: SET_USER_MARKET_FILTER,
  payload: userMarketFilter
});

export const setUserMarkets = (userMarkets) => ({ type: SET_USER_MARKETS, payload: userMarkets });

export const setUserRoles = (roles) => ({ type: SET_USER_ROLES, payload: roles });

export const resetUserRoles = () => ({ type: RESET_USER_ROLES });

export const setLocations = ({ market, locations }) => ({
  type: SET_LOCATIONS,
  payload: { market, locations }
});

export const resetLocations = () => ({ type: RESET_LOCATIONS });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setLoadingId = (id) => ({ type: SET_LOADING_ID, payload: id });

export const removeLoadingId = (id) => ({ type: REMOVE_LOADING_ID, payload: id });

export const setError = (error) => ({ type: SET_ERROR, payload: error });

export const setAppTypesGroups = (appTypesGroups) => ({
  type: SET_APP_TYPES_GROUPS,
  payload: appTypesGroups
});

export const setUserAppTypes = (appTypes) => ({ type: SET_USER_APP_TYPES, payload: appTypes });

export const setGroupsConfigs = ({ appType, groups }) => ({
  type: SET_GROUPS_CONFIGS,
  payload: { appType, groups }
});

export const resetGroupsConfigs = () => ({ type: RESET_GROUPS_CONFIGS });

export const setAppVersion = (appVersion) => ({ type: SET_APP_VERSION, payload: appVersion });

export const setIsNeedToResetTextEditorState = (value) => ({
  type: SET_IS_NEED_TO_RESET_TEXT_EDITOR_STATE,
  payload: value
});
